import { useMPEFetch } from '@retail/app/hooks';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { mpeApi } from '@retail/mgpris/config';
import { PriceSuggestionPriceDTO } from '@retail/price-suggestion/types';
import { QueryOptions } from '@shared/fetch-utils';
import { buildUrl } from '@shared/utils';

interface SearchProps {
  assortmentId: number;
  includeOwner?: boolean;
  mgItemNumber: number;
  mgSupplierId: number;
}

export function useFetchPriceSuggestionItemPrices(
  { assortmentId, includeOwner = true, mgItemNumber, mgSupplierId }: SearchProps,
  queryOptions: QueryOptions = {}
) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<PriceSuggestionPriceDTO[]>({
    method: 'GET',
    queryKey: [
      'price-suggestion-item-prices',
      assortmentId,
      includeOwner,
      mgItemNumber,
      mgSupplierId,
    ],
    token,
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.priceSuggestion.itemPrices.getFullLinkPath(),
      searchParams: {
        includeOwner,
        'assortment-id': assortmentId,
        'mg-item-number': mgItemNumber,
        'mg-supplier-id': mgSupplierId,
      },
    }),
    ...queryOptions,
  });
}
